import React from "react";

const IVR = () => {
  return (
    <>
      <div className="info">
        <p>
          {" "}
          Interactive Voice Response – Respuesta de Voz Interactiva.
          <br />
          Los IVR permiten llegar a los clientes de una manera rápida y efectiva
          por segmentación. Explicar bien lo que quiere comunicar, ya que un
          audio es muy efectivo al momento de comunicar lo que queremos decir, y
          amplía las posibilidades, considerablemente, de convencimiento.
        </p>
      </div>
      <div className="table">
        <div>
          <h4>Usos</h4>
          <ul>
            <li>Investigación de Mercado.</li>
            <li>Gestión de Cobranzas.</li>
            <li>Venta Directa.</li>
            <li>Atención a Clientes.</li>
            <li>Campañas Publicitarias.</li>
            <li> Encuestas Telefónicas.</li>
            <li>Pago a Proveedores.</li>
            <li> Toma de Pedidos.</li>
            <li>Llamados Salientes.</li>
          </ul>
        </div>
        <div>
          <h4>Beneficios</h4>
          <ul>
            <li>Es Rápido.</li>
            <li>Es Efectivo.</li>
            <li> Es Directo.</li>
            <li> Permite Segmentar.</li>
            <li>Amplía las Posibilidades de Convencimiento.</li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default IVR;
